import React from 'react'
import styles from './ChatBubbleSimple.module.scss'

const ChatBubble = ({ arrow = true, children }) => {
  return (
    <div
      className={`
        ${styles.bubble}
        ${arrow && styles.arrowDown}
      `}
    >
      {children}
    </div>
  )
}

export default ChatBubble
